import { ulid } from "ulid"
import { createTriggerActionUtils, ITriggerAction } from "@droid/project-v2-interface"
import { actionOpenAppUtils } from "../actions/app/action-open-app/IActionOpenApp.inft"
import { triggerTimeoutUtils } from "../triggers/time/timeout/ITriggerTimeout.inft"
import { triggerActionsNamespace } from "./trigger-actions-namespace"

const type = `${triggerActionsNamespace}${triggerTimeoutUtils.type}-${actionOpenAppUtils.type}`

type ITimeOutOpenAppTriggerAction = ITriggerAction

function createDefaultData(): ITimeOutOpenAppTriggerAction {
    const ulidValue = ulid()
    const triggerGroupUlid = ulid()
    const actionGroupUlid = ulid()
    return {
        
        ulid: ulidValue,
        uuid: '',
        ownerUuid: '',
        currentVersion: 0,
        name: "",
        type,
        triggerGroupUlid,
        actionGroupUlid,
        triggerGroupUuid: '',
        actionGroupUuid: '',
        triggerGroup: {
            
            ulid: triggerGroupUlid,
            uuid: '',
            ownerUuid: '',
            currentVersion: 0,
            isSequential: false,
            type: 'triggerGroup',
            list: [triggerTimeoutUtils.createDefaultData()],
            checks: [[true]],
            createdAt: 0,
            updatedAt: 0,
            authorUuid: '',
        },
        actionGroup: {
            
            ulid: actionGroupUlid,
            uuid: '',
            ownerUuid: '',
            currentVersion: 0,
            isSequential: false,
            type: 'actionGroup',
            list: [actionOpenAppUtils.createDefaultData()],
            checks: [[true]],
            createdAt: 0,
            updatedAt: 0,
            authorUuid: '',
        },
        triggerGroupVersion: 0,
        actionGroupVersion: 0,
        createdAt: 0,
        updatedAt: 0,
        authorUuid: '',
    }
}

export const timeOutOpenAppTriggerActionUtils = createTriggerActionUtils(type, createDefaultData)
